export const services = [
  {
    id: 1,
    title: "Forklift Rentals",
    description: "Short-term and long-term forklift rentals for all industrial needs",
    icon: "bi-truck",
    category: "rentals",
    features: ["Daily/Monthly Rental", "Operator Training", "Insurance Included"]
  },
  {
    id: 2,
    title: "Spare Parts",
    description: "Genuine spare parts for all major forklift brands",
    icon: "bi-gear",
    category: "parts",
    subcategories: ["Self Starters", "Tyres", "Batteries", "Hydraulic Parts"]
  },
  {
    id: 3,
    title: "Maintenance Services",
    description: "Regular maintenance and emergency repair services",
    icon: "bi-tools",
    category: "services",
    features: ["Preventive Maintenance", "24/7 Emergency Service", "Annual Contracts"]
  },
  {
    id: 4,
    title: "Forklift Sales",
    description: "New and certified pre-owned forklifts",
    icon: "bi-cart",
    category: "sales",
    features: ["Brand New Models", "Certified Used", "Warranty Included"]
  },
  {
    id: 5,
    title: "Operator Training",
    description: "Certified forklift operator training programs",
    icon: "bi-person-badge",
    category: "training",
    features: ["Certification", "Safety Training", "On-site Training"]
  },
  {
    id: 6,
    title: "Battery Services",
    description: "Forklift battery sales, rental, and maintenance",
    icon: "bi-battery-charging",
    category: "services",
    features: ["Battery Rental", "Charger Services", "Maintenance"]
  }
];

export const companyInfo = {
  name: "Aarav Enterprises",
  tagline: "Let Me Lift You Up",
  address: "Shop 4 Sharma Complex Samardha Bhopal (M.P) - 462047",
  gst: "GSTIN: 23GOZPS6344G2Z5",
  phone: "+91 97550 53892, +91 83190 04362",
  primaryphone: "+919755053892",
  email: "aaraventerprises993@gmail.com",
  workingHours: "Mon - Sat: 8:00 AM - 8:00 PM"
};

export const forkliftTypes = [
  "Electric Forklifts",
  "Diesel Forklifts",
  "LPG Forklifts",
  "Reach Trucks",
  "Pallet Trucks",
  "Order Pickers"
];